// Import the Hero component for displaying the page banner
import Hero from "../../frontend/components/Hero";
// Import an image to use as the background for the Hero section
import CalculatorsImag1 from "../../assets/images/checking-data-laptop.jpg";
// Import the calculator component for "How Much Will It Cost"
import HowMuchWillItCostCalculator from "../../frontend/components/calculators/HowMuchWillItCostCalculator";

// Main page component for the "How Much Will It Cost" calculator
const HowMuchWillItCostPage = () => {
  return (
    <div>
      {/* Hero section with title and background image */}
      <Hero
        title="How Much Will It Cost"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      {/* Render the How Much Will It Cost Calculator */}
      <HowMuchWillItCostCalculator />
      {/* Placeholder for additional content or layout, currently commented out */}
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

// Export the page component as default
export default HowMuchWillItCostPage;
